import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './i18n';
import './index.css';
import './ViewTabs.css'; // the portal's one tab-bar look (01/11) — TabIcon.jsx gives each tab its icon
// Generated dark counterparts of every colour rule (scripts/build_dark_theme.py). Inert unless <html> carries
// data-theme="dark", and bundled into the same CSS file, so it costs no extra request and no runtime work.
import './theme-dark.css';
import './theme-dark-overrides.css'; // hand-written dark fixes — after the generated sheet, so they win
import './theme-christmas-patterns.css'; // the Christmas SVG tiles (generated by scripts/build_xmas_patterns.py)
import './theme-christmas.css'; // the Christmas season (season.js) — one attribute on <html>, frame + Home + login only
import { initSeason } from './season';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';
import installSessionGuard from './sessionGuard';
import installLoopCapture from './loopCapture';
import MasterData from './27_MasterData';
import Register from './01_Register';
import Login from './02_Login';
import ResetPasswordRequest from './03_ResetPasswordRequest';
import RequestAccess from './42_RequestAccess';
import AccessRequests from './43_AccessRequests';
import ResetPasswordForm from './03_ResetPasswordForm';
import Home from './04_Home';
import UnitSalesDashboard from './05_UnitSalesDashboard';
import AutoJobsMenu from './06_AutoJobsMenu';
import SalesOpJob from './07_SalesOpJob';
import SopWeekly, { SOP_WEEKLY_ON, SOP_WEEKLY_OFF_MARK } from './59_SopWeekly';
import Profile from './08_UserProfile';
import ListUsers from './09_ListUsers';
import EditUser from './10_EditUser';
import Unauthorized from './11_AccessDenied';
import SalesReportDashboard from './12_SalesReportDashboard';
import GoogleRegister from './13_GoogleRegister';
import DemandForecastDashboard from './14_DemandForecastDashboard';
import SampleTracker from './15_SampleTracker';
import DocumentLibrary from './38_DocumentLibrary';
import SPHub from './23_SPHub';
import MasterSheet from './28_MasterSheet';
import PricingCalculator from './29_PricingCalculator';
import BenchmarkLibrary from './39_BenchmarkLibrary';
import CeoOffice from './40_CeoOffice';
import Gtm from './41_Gtm';
import GtmTracker from './50_GtmTracker';
import PartnerSamples from './51_PartnerSamples';
import CashSetup from './42_CashSetup';
import CashReport, { CashReportLegacy } from './49_CashReport';
import CashImport from './46_CashImport';
import CashApproval from './48_CashApproval';
import Courier from './52_Courier';
import DriverLog from './53_DriverLog';
import SalesPlanning, { SalesPlanningLegacy } from './54_SalesPlanning';
import DataExplorer from './55_DataExplorer';
import SalesDataLoad from './56_SalesDataLoad';
import InventoryReport from './57_InventoryReport';
import PoleInventory from './58_PoleInventory';
import EusuStock from './60_EusuStock';
import SalesByBuyer from './66_SalesByBuyer';
import ModelColor from './67_ModelColor';
import StaffPurchase from './68_StaffPurchase';
import AiHub from './61_AiHub';
import Gcc from './62_Gcc';
import TaskBoard from './64_TaskBoard';
import UserManual from './65_UserManual';
import Noos from './63_Noos';
import { SPL_SCREENS } from './salesPlanningScreens';
import OpaSctPage from './31_OpaSctPage';
import SctSummaryPage from './33_SctSummaryPage';
import ProductLine from './26_ProductLine';
import Capacity from './34_Capacity';
import SapShipDoc from './36_SapShipDoc';
import CapacityOutput from './37_CapacityOutput';
import PricingApproval from './35_PricingApproval';
import ProjectReport from './16_ProjectReport';
import ProjectApproval from './24_ProjectApproval';
import TaskStatus from './17_TaskStatus';
import AssignPeoplePage from './AssignPeoplePage';
import NFCPortal from './18_NFCPortal';
import RoleManagement from './19_RoleManagement';
import ActivityLog from './20_ActivityLog';
import PortalInsights from './22_PortalInsights';
import ImprovementLoop from './69_ImprovementLoop';
import AiUsage from './71_AiUsage';
import ProductionStatus from './70_ProductionStatus';
import ProtectedRoute from './ProtectedRoute';
import { ThemeProvider } from './ThemeContext';

/* Same switch the sidebar uses — a route left open is a working screen for anybody who
   types the path, which on production would be a screen whose every call answers 404. */
const GTM_ON = process.env.REACT_APP_GTM === '1';
const CASH_ON = process.env.REACT_APP_CASH === '1';
/* A partner company's own sample track (DAC VN, Jay 2026-10-17). Staging only: the backend half is
   PARTNER_TRACK=1 in /app/backend-staging/.env, and deploy_production.sh refuses a bundle carrying it. */
const PARTNER_ON = process.env.REACT_APP_PARTNER === '1';
const COURIER_ON = process.env.REACT_APP_COURIER === '1';
const DRIVERLOG_ON = process.env.REACT_APP_DRIVERLOG === '1';
const SALESPLAN_ON = process.env.REACT_APP_SALES_PLANNING === '1';
const EXPLORER_ON = process.env.REACT_APP_EXPLORER === '1';
const SALES_CW_ON = process.env.REACT_APP_SALES_CW === '1';
const INVENTORY_ON = process.env.REACT_APP_INVENTORY === '1';
const POLE_ON = process.env.REACT_APP_POLE === '1';
const EUSU_ON = process.env.REACT_APP_EUSU === '1';
const STAFFBUY_ON = process.env.REACT_APP_STAFF_PURCHASE === '1';
const AI_HUB_ON = process.env.REACT_APP_AI_HUB === '1';
const GCC_ON = process.env.REACT_APP_GCC === '1';
const TASKS_ON = process.env.REACT_APP_TASKS === '1';
const NOOS_ON = process.env.REACT_APP_NOOS === '1';
const PSR_ON = process.env.REACT_APP_PSR === '1';

// Send the auth cookie on every axios request so backend-guarded endpoints (RBAC) authenticate.
axios.defaults.withCredentials = true;
/* A 401 anywhere means the 2-hour session ended while the tab sat open — send the person to sign in
   and bring them back, instead of showing them "Unauthorized, token missing" (Max, 2026-08-25). */
installSessionGuard();
// the screen's own errors for the improvement loop (Jay #1137, loopCapture.js)
installLoopCapture();
initSeason();

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
        <Route
          path="/register"
          element={
            <ProtectedRoute requiredFunction="user_management">
              <Register />
            </ProtectedRoute>
          }
        />
        <Route path="/login" element={<Login />} />
        <Route
          path="/admin/roles"
          element={
            <ProtectedRoute requiredFunction="role_management">
              <RoleManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/activity-log"
          element={
            <ProtectedRoute requiredFunction="audit_log">
              <ActivityLog />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/portal-insights"
          element={
            <ProtectedRoute requiredFunction={['usage_analytics', 'quote_management']}>
              <PortalInsights />
            </ProtectedRoute>
          }
        />
        {/* PRODUCTION STATUS (PSR, Jay 01/11): HEVN reads every vendor, a vendor account (TS, MS) its own rows — the server decides */}
        <Route
          path={PSR_ON ? "/production-status" : "/__psr_off"}
          element={
            <ProtectedRoute requiredFunction={['production_status', 'psr_vendor']}>
              <ProductionStatus />
            </ProtectedRoute>
          }
        />
        {/* errors and feedback, Admin only (Jay #1137 / #1138) */}
        <Route
          path="/admin/improvement-loop"
          element={
            <ProtectedRoute requiredFunction="improvement_loop">
              <ImprovementLoop />
            </ProtectedRoute>
          }
        />
        {/* the portal's AI cost, caps, effort and prices, Admin only (Jay #1179 / #1181) */}
        <Route
          path="/admin/ai-usage"
          element={
            <ProtectedRoute requiredFunction="ai_usage">
              <AiUsage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/master-data"
          element={
            <ProtectedRoute requiredFunction="master_data">
              <MasterData />
            </ProtectedRoute>
          }
        />
        <Route path="/development/ticket/:token" element={<TaskStatus />} />
        {/* The managers arrive here from the approval notice, with a session — the ticket
            link is the other door onto the same screen. */}
        <Route path="/development/assign/:groupId" element={<AssignPeoplePage />} />
        <Route path="/google-register" element={<GoogleRegister />} />
        <Route path="/reset-password-request" element={<ResetPasswordRequest />} />
        <Route
          path="/admin/access-requests"
          element={
            <ProtectedRoute requiredFunction="user_management">
              <AccessRequests />
            </ProtectedRoute>
          }
        />
        {/* PUBLIC ON PURPOSE. It is the one page somebody with no account needs to be
            able to reach, and it grants nothing — see 42_RequestAccess.jsx. */}
        <Route path="/request-access" element={<RequestAccess />} />
        <Route path="/reset-password" element={<ResetPasswordForm />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Home />
            </ProtectedRoute>
          }
        />
        <Route
          path="/product-sales-dashboard"
          element={
            <ProtectedRoute requiredFunction="product_sales_dashboard">
              <UnitSalesDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales-report-dashboard"
          element={
            <ProtectedRoute requiredFunction="sales_report_dashboard">
              <SalesReportDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/demand-forecast-dashboard"
          element={
            <ProtectedRoute requiredFunction="demand_forecast_dashboard">
              <DemandForecastDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/development/sample-tracker"
          element={
            <ProtectedRoute requiredFunction={['project_tracker', 'sample_tracker', 'ticket_station']}>
              <SampleTracker />
            </ProtectedRoute>
          }
        />
        {/* The Document Library. TWO routes for one screen: /documents is the list, /documents/HB-001
            is the permanent URL a notification mail links to — it resolves to the latest version, for
            ever, which is the promise that replaces sending the file (Jay, 2026-09-08). */}
        <Route
          path="/documents"
          element={
            <ProtectedRoute requiredFunction="document_library">
              <DocumentLibrary />
            </ProtectedRoute>
          }
        />
        {/* GTM programmes. TWO routes for one screen, the same shape the Document Library uses:
            /gtm is the list and /gtm/GTM-26-001 is the programme, so a link to one survives being
            pasted into a mail. */}
        <Route
          path={GTM_ON ? "/gtm" : "/__gtm_off"}
          element={
            <ProtectedRoute requiredFunction="gtm_programme">
              <Gtm />
            </ProtectedRoute>
          }
        />
        {/* EITHER GTM GRANT OPENS A PROGRAMME, and the server decides what can be done on it: an
            approver who follows an author's link lands on the sheet read-only rather than on
            /unauthorized — and the PDF renderer, which drives this route with the caller's own
            session, works for an approver too. */}
        <Route
          path={GTM_ON ? "/gtm/:code" : "/__gtm_off_detail"}
          element={
            <ProtectedRoute requiredFunction={['gtm_programme', 'gtm_approval']}>
              <Gtm />
            </ProtectedRoute>
          }
        />
        {/* THE APPROVER'S SCREEN — Max, 2026-10-08: "hiện giao diện của người tạo và người approve
            ko tách ra nên nhiều phiếu GTM thì sẽ lẫn lộn vào nhau". Its own pair of routes and its
            own grant, the way Project Approval stands beside Project Tracker. */}
        <Route
          path={GTM_ON ? "/gtm-approval" : "/__gtm_off_approval"}
          element={
            <ProtectedRoute requiredFunction="gtm_approval">
              <Gtm mode="approval" />
            </ProtectedRoute>
          }
        />
        <Route
          path={GTM_ON ? "/gtm-approval/:code" : "/__gtm_off_approval_detail"}
          element={
            <ProtectedRoute requiredFunction="gtm_approval">
              <Gtm mode="approval" />
            </ProtectedRoute>
          }
        />
        {/* A PARTNER COMPANY'S OWN SAMPLE TRACK (DAC VN, Jay 2026-10-17). A partner's account is sent here
            from every other path by ProtectedRoute; HEVN reaches it from the Development menu. */}
        <Route
          path={PARTNER_ON ? "/partner-samples" : "/__partner_off"}
          element={
            <ProtectedRoute requiredFunction="partner_samples">
              <PartnerSamples />
            </ProtectedRoute>
          }
        />
        {/* GTM TRACKER — So-yeon's point 8 (2026-10-16): the approved programmes and how far their
            timeline has got. Either GTM grant reads it; the server decides who may change a step. */}
        <Route
          path={GTM_ON ? "/gtm-tracker" : "/__gtm_off_tracker"}
          element={
            <ProtectedRoute requiredFunction={['gtm_programme', 'gtm_approval']}>
              <GtmTracker />
            </ProtectedRoute>
          }
        />
        {/* CASH REPORT — SET UP (2026-10-08). The User list inside the module decides what a
            person may do; `cash_report` only opens the door, and /portal-auth hands it to the
            people that list names. */}
        <Route
          path={CASH_ON ? "/cash/setup" : "/__cash_off"}
          element={
            <ProtectedRoute requiredFunction="cash_report">
              <CashSetup />
            </ProtectedRoute>
          }
        />
        {/* THE IMPORT MODULE — Templates 1-3, the Preparer's input; the three report screens
            below are what is made of it. */}
        <Route
          path={CASH_ON ? "/cash/import" : "/__cash_off_import"}
          element={
            <ProtectedRoute requiredFunction="cash_report">
              <CashImport />
            </ProtectedRoute>
          }
        />
        {/* THE APPROVAL SCREEN (2026-10-15) — the Reviewer's, Group CFO's and CEO's queue; the
            report screens below are for reading. */}
        {/* SALES PLANNING (2026-10-20) — the monthly order & ex-factory program, one screen per person who takes part.
            Staging only — behind REACT_APP_SALES_PLANNING; the backend half is SALES_PLANNING_MODULE. */}
        {SPL_SCREENS.map((sc) => (
          <Route
            key={sc.key}
            path={SALESPLAN_ON ? sc.path : `/__salesplan_off_${sc.key}`}
            element={
              <ProtectedRoute requiredFunction={sc.grants}>
                <SalesPlanning screen={sc.key} />
              </ProtectedRoute>
            }
          />
        ))}
        <Route
          path={SALESPLAN_ON ? "/sales-planning" : "/__salesplan_off"}
          element={
            <ProtectedRoute requiredFunction={['sales_planning', 'sales_planning_manager', 'sales_planning_factory']}>
              <SalesPlanningLegacy />
            </ProtectedRoute>
          }
        />
        {/* DATA EXPLORER (2026-10-22) — the Power-BI-like tool. Staging only — behind REACT_APP_EXPLORER; the backend
            half is EXPLORER_MODULE. Each dataset also asks for its own screen's grant, on the server. */}
        <Route
          path={EXPLORER_ON ? "/data-explorer" : "/__explorer_off"}
          element={
            <ProtectedRoute requiredFunction="data_explorer">
              <DataExplorer />
            </ProtectedRoute>
          }
        />
        {/* SALES DATA LOAD (2026-10-22) — Max's weekly CW sales update as a job. Staging only — behind REACT_APP_SALES_CW;
            the backend half is SALES_CW_MODULE. */}
        <Route
          path={SALES_CW_ON ? "/sales-data-load" : "/__salescw_off"}
          element={
            <ProtectedRoute requiredFunction="sales_cw_load">
              <SalesDataLoad />
            </ProtectedRoute>
          }
        />
        {/* INVENTORY REPORT (2026-10-23) — the weekly S&OP inventory. Staging only — behind REACT_APP_INVENTORY; the backend
            half is INVENTORY_MODULE. */}
        <Route
          path={INVENTORY_ON ? "/inventory-report" : "/__inventory_off"}
          element={
            <ProtectedRoute requiredFunction="inventory_report">
              <InventoryReport />
            </ProtectedRoute>
          }
        />
        {/* AI HUB (2026-10-27) — departments' instructions and files, questions answered from them, lessons, the change log.
            Staging only — behind REACT_APP_AI_HUB; the backend half is AI_HUB. Its own grant, ai_hub (view = ask; edit = admin). */}
        <Route
          path={AI_HUB_ON ? "/ai-hub" : "/__aihub_off"}
          element={
            <ProtectedRoute requiredFunction="ai_hub">
              <AiHub />
            </ProtectedRoute>
          }
        />
        {/* NOOS ORDERING DASHBOARD (2026-10-27): Young's NOOS ordering sheet as a screen. On production since 2026-10-27,
            behind REACT_APP_NOOS; the backend half is NOOS_MODULE=1. Grant noos_dashboard. */}
        <Route
          path={NOOS_ON ? "/noos" : "/__noos_off"}
          element={
            <ProtectedRoute requiredFunction="noos_dashboard">
              <Noos />
            </ProtectedRoute>
          }
        />
        {/* Supply Planning (Jay, 28/10) — the same screen under its Production menu name; /noos above keeps old links working */}
        <Route
          path={NOOS_ON ? "/production/supply-planning" : "/__noos_off2"}
          element={
            <ProtectedRoute requiredFunction="noos_dashboard">
              <Noos />
            </ProtectedRoute>
          }
        />
        {/* THE USER MANUALS inside the portal (Jay, task #99, 30/10) — no grant: the menu shows each to whoever it did as a
            link, and each handbook's own route still checks its reader. /manual and not /user-manual: staging's nginx sends
            every path starting /user (its `users?` regex) to the backend, so a reload there answered Express's 404. */}
        <Route
          path="/manual/:which"
          element={
            <ProtectedRoute>
              <UserManual />
            </ProtectedRoute>
          }
        />
        {/* TASK BOARD (2026-10-30, Max): a Kanban board per person. Production since 30/10 — behind REACT_APP_TASKS; the backend half is
            TASK_BOARD=1. Grant task_board. */}
        <Route
          path={TASKS_ON ? "/tasks" : "/__tasks_off"}
          element={
            <ProtectedRoute requiredFunction="task_board">
              <TaskBoard />
            </ProtectedRoute>
          }
        />
        {/* GCC — GROUP CHAT WITH CATCHY (2026-10-27): rooms, Catchy on @mention and in a side window. Staging only — behind
            REACT_APP_GCC; the backend half is GCC=1. It uses the AI Hub's grant (ai_hub). */}
        <Route
          path={GCC_ON ? "/gcc" : "/__gcc_off"}
          element={
            <ProtectedRoute requiredFunction="ai_hub">
              <Gcc />
            </ProtectedRoute>
          }
        />
        {/* SALES BY BUYER & COUNTRY (task #96, Anh Le — Sales Team 1's monthly workbook, read from SAP). Grant sales_buyer_country. */}
        <Route
          path="/sales-by-buyer"
          element={
            <ProtectedRoute requiredFunction="sales_buyer_country">
              <SalesByBuyer />
            </ProtectedRoute>
          }
        />
        {/* FRAMES BY MODEL & COLOUR (task #96 report 2 — from the uploaded Order Status master). Grant sales_model_color. */}
        <Route
          path="/frames-by-model"
          element={
            <ProtectedRoute requiredFunction="sales_model_color">
              <ModelColor />
            </ProtectedRoute>
          }
        />
        {/* STAFF PURCHASE (task #1132, 2026-11-01) — the Global Staff Purchase Procedure Rev. 3. Staging only — behind
            REACT_APP_STAFF_PURCHASE; the backend half is STAFF_PURCHASE. Grant staff_purchase (every Helinox role). */}
        <Route
          path={STAFFBUY_ON ? "/staff-purchase" : "/__staffbuy_off"}
          element={
            <ProtectedRoute requiredFunction="staff_purchase">
              <StaffPurchase />
            </ProtectedRoute>
          }
        />
        {/* EUSU NON-SELLING STOCK (2026-10-26) — the weekly EUSU stock status workbook as a screen. Staging only — behind
            REACT_APP_EUSU; the backend half is EUSU_STOCK. Its own grant, eusu_stock (view; edit = upload). */}
        <Route
          path={EUSU_ON ? "/eusu-stock" : "/__eusu_off"}
          element={
            <ProtectedRoute requiredFunction="eusu_stock">
              <EusuStock />
            </ProtectedRoute>
          }
        />
        {/* GLOBAL POLE INVENTORY (2026-10-24) — the frames' monthly stock movement. Staging only — behind REACT_APP_POLE;
            the backend half is POLE_INVENTORY_MODULE. */}
        <Route
          path={POLE_ON ? "/pole-inventory" : "/__pole_off"}
          element={
            <ProtectedRoute requiredFunction="pole_inventory">
              <PoleInventory />
            </ProtectedRoute>
          }
        />
        {/* DRIVER'S LOG (Jay, 2026-10-19) — the company cars' daily log. Staging only — behind REACT_APP_DRIVERLOG;
            the backend half is DRIVER_LOG_MODULE. One route for both: a driver gets the phone screen, an admin the tabs. */}
        <Route
          path={DRIVERLOG_ON ? "/driver-log" : "/__driverlog_off"}
          element={
            <ProtectedRoute requiredFunction={['driver_log', 'driver_log_admin']}>
              <DriverLog />
            </ProtectedRoute>
          }
        />
        {/* COURIER SHIPPING APPROVAL (Tina, 2026-10-19). Staging only — behind REACT_APP_COURIER, and the
            backend half is COURIER_MODULE. The approver named in courier.approver gets courier_approval
            from /portal-auth, whatever role they hold. */}
        <Route
          path={COURIER_ON ? "/courier" : "/__courier_off"}
          element={
            <ProtectedRoute requiredFunction="courier_request">
              <Courier mode="request" />
            </ProtectedRoute>
          }
        />
        <Route
          path={COURIER_ON ? "/courier-approval" : "/__courier_off_approval"}
          element={
            <ProtectedRoute requiredFunction="courier_approval">
              <Courier mode="approval" />
            </ProtectedRoute>
          }
        />
        <Route
          path={CASH_ON ? "/cash/approval" : "/__cash_off_approval"}
          element={
            <ProtectedRoute requiredFunction="cash_report">
              <CashApproval />
            </ProtectedRoute>
          }
        />
        {/* The three reports are ONE module (2026-10-15); their old addresses open its tabs. */}
        <Route
          path={CASH_ON ? "/cash/report" : "/__cash_off_report"}
          element={
            <ProtectedRoute requiredFunction="cash_report">
              <CashReport />
            </ProtectedRoute>
          }
        />
        <Route
          path={CASH_ON ? "/cash/weekly" : "/__cash_off_weekly"}
          element={
            <ProtectedRoute requiredFunction="cash_report">
              <CashReportLegacy tab="weekly" />
            </ProtectedRoute>
          }
        />
        <Route
          path={CASH_ON ? "/cash/plan" : "/__cash_off_plan"}
          element={
            <ProtectedRoute requiredFunction="cash_report">
              <CashReportLegacy tab="plan" />
            </ProtectedRoute>
          }
        />
        <Route
          path={CASH_ON ? "/cash/month-end" : "/__cash_off_monthend"}
          element={
            <ProtectedRoute requiredFunction="cash_report">
              <CashReportLegacy tab="monthend" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/documents/:code"
          element={
            <ProtectedRoute requiredFunction="document_library">
              <DocumentLibrary />
            </ProtectedRoute>
          }
        />
        <Route
          path="/production/sp-hub"
          element={
            <ProtectedRoute requiredFunction="sp_hub">
              <SPHub />
            </ProtectedRoute>
          }
        />
        <Route
          path="/sales/pricing-calculator"
          element={
            <ProtectedRoute requiredFunction="collab_pricing">
              <PricingCalculator />
            </ProtectedRoute>
          }
        />
        {/* CEO OFFICE — Young, 2026-09-14. Its own grant: the section is his, and who may open it
            is a different question from who may open anything else in the portal. */}
        <Route
          path="/ceo-office"
          element={
            <ProtectedRoute requiredFunction="ceo_office">
              <CeoOffice />
            </ProtectedRoute>
          }
        />
        {/* The vendor cost sheets the Inline benchmark is filled from, kept. Its own screen for
            the same reason Pricing Approval is one — tidying a library is not pricing a quote —
            but the SAME grant: it is the calculator's own data, and a separate key would have to
            be handed out before anybody could see what their own imports had filed. */}
        <Route
          path="/sales/inline-cost-sheets"
          element={
            <ProtectedRoute requiredFunction="collab_pricing">
              <BenchmarkLibrary />
            </ProtectedRoute>
          }
        />
        {/* Costing. Its own module in the menu since 2026-08-29; the function key is shared with the
            pricing calculator because it is the same team and the same kind of document. */}
        {/* The gate is its own screen, next to Project Approval in shape: a queue of decisions is
            not the same job as a list of everything ever saved. */}
        {/* Staging only while the gate is being built: production has no mail switch, so a Submit
            there reaches the real team manager. The route is left out entirely rather than hidden,
            so the URL cannot be reached by typing it. */}
        {process.env.REACT_APP_PRICING_APPROVAL === '1' && (
          <Route
            path="/sales/pricing-approval"
            element={
              <ProtectedRoute requiredFunction="pricing_approval">
                <PricingApproval />
              </ProtectedRoute>
            }
          />
        )}
        <Route
          path="/costing/opa-sct"
          element={
            <ProtectedRoute requiredFunction="opa_sct">
              <OpaSctPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/costing/sct-summary"
          element={
            <ProtectedRoute requiredFunction="opa_sct">
              <SctSummaryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/production/master-sheet"
          element={
            <ProtectedRoute requiredFunction="sp_master_sheet">
              <MasterSheet />
            </ProtectedRoute>
          }
        />
        <Route
          path="/production/product-line"
          element={
            <ProtectedRoute requiredFunction="sp_hub">
              <ProductLine />
            </ProtectedRoute>
          }
        />
        <Route
          path="/production/capacity"
          element={
            <ProtectedRoute requiredFunction="capacity">
              <Capacity />
            </ProtectedRoute>
          }
        />
        <Route
          path="/production/output"
          element={
            <ProtectedRoute requiredFunction={['capacity_vendor', 'capacity']}>
              <CapacityOutput />
            </ProtectedRoute>
          }
        />
        <Route
          path="/production/sap-ship-doc"
          element={
            <ProtectedRoute requiredFunction="sap_ship_doc">
              <SapShipDoc />
            </ProtectedRoute>
          }
        />
        <Route
          path="/development/project-approval"
          element={
            <ProtectedRoute requiredFunction={['project_tracker_approve', 'project_tracker_create']}>
              <ProjectApproval />
            </ProtectedRoute>
          }
        />
        <Route
          path="/development/project-tracker/report"
          element={
            <ProtectedRoute requiredFunction="project_tracker">
              <ProjectReport />
            </ProtectedRoute>
          }
        />
        <Route
          path="/production/nfc"
          element={
            <ProtectedRoute requiredFunction="nfc_portal">
              <NFCPortal />
            </ProtectedRoute>
          }
        />
        <Route
          path="/auto-jobs-menu"
          element={
            <ProtectedRoute requiredFunction="auto_jobs">
              {/* the one-button page is skipped with the new screen on; an old bookmark lands on the screen itself */}
              {SOP_WEEKLY_ON ? <Navigate to="/run-python-sop-team" replace /> : <AutoJobsMenu />}
            </ProtectedRoute>
          }
        />
        <Route
          path="/run-python-sop-team"
          element={
            <ProtectedRoute requiredFunction="auto_jobs_sop_team">
              {/* Sales Op Weekly Report (2026-10-24): files, run and report on one screen — staging only for now */}
              {SOP_WEEKLY_ON ? <SopWeekly /> : <><SalesOpJob /><span hidden data-off={SOP_WEEKLY_OFF_MARK} /></>}
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile/:userId"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/list-user"
          element={
            <ProtectedRoute requiredFunction="user_management">
              <ListUsers />
            </ProtectedRoute>
          }
        />
        <Route
          path="/edit-user/:userId"
          element={
            <ProtectedRoute requiredFunction="user_management">
              <EditUser />
            </ProtectedRoute>
          }
        />
        <Route
          path="/unauthorized"
          element={
            <ProtectedRoute>
              <Unauthorized />
            </ProtectedRoute>
          }
        />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
